module.exports = __webpack_public_path__ + "static/media/add_inactive.36a260ea.svg";